import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import {
  ContainerData,
  LabelData,
  ContainerProdCons,
  TitleProdCons,
  TotalKg,
  AddButton,
  Icon,
  HeadTable,
  RowTable,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "./productionOrderSapDetail.styled";
import Breadcrumb from "../../../utils/breadCrumbs";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import {
  POSAP_STATUS,
  POSAP_STATUS_NOTIFICATED,
  POSAP_STATUS_PENDING,
  POSAP_STATUS_READY_TO_SEND,
} from "../../../../constants";
import { useProductionOrderSapExtraInfo } from "../hook/useProductionOrderSapExtraInfo";
import { useNotificationSap } from "../hook/useNotificationSap";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";

const ProductionOrderSapDetailView = ({
  goBack,
  handlerOnExtraInfo,
  orderData,
  refresh,
  onExportExcel,
}) => {
  const { t } = useTranslation();

  const refreshView = () => {
    if (refresh) refresh();
  };
  const { notify } = useProductionOrderSapExtraInfo(refreshView);
  const { createNotification, editNotification, deleteNotification } =
    useNotificationSap(refreshView);

  const breads = [
    { label: t("home"), path: PATHS.HOME },
    {
      label: t("forms.productionOrderSap.title"),
      path: PATHS.PRODUCTION_ORDER_SAP_LIST,
    },
    { label: t("forms.productionOrderSap.detailTitle") },
  ];
  const renderProduction = (productions) => {
    if (productions && productions.length > 0) {
      return (
        <>
          <HeadTable className="row header">
            <div className="col-3">
              {t("forms.productionOrderSap.table.head.date")}
            </div>
            <div className="col-2">
              {t("forms.productionOrderSap.table.head.batch")}
            </div>
            <div className="col-2">
              {t("forms.productionOrderSap.table.head.product")}
            </div>
            <div className="col-2">
              {t("forms.productionOrderSap.table.head.typeMov")}
            </div>
            <div className="col-2">
              {t("forms.productionOrderSap.table.head.quantity")}
            </div>
            <Can do={USER_PERMISSIONS.CAN_EDIT_SAP_NOTIFICATION}>
              <div className="col-1"></div>
            </Can>
          </HeadTable>
          {productions.map((bb) => {
            return (
              <RowTable className="row mb-1 align-items-center" key={bb.uuid}>
                <div className="col-3">{`${getDateFormatTimeZone(
                  bb.sapDocumentDate,
                  "DD-MM-yyyy HH:mm:ss",
                )}`}</div>
                <div className="col-2">{bb.sapBatch}</div>
                <div className="col-2">{`${bb.sapMaterial}`}</div>
                <div className="col-2">{`${bb.sapType}`}</div>
                <div className="col-2">{`${bb.sapQuantityEntry}Kg`}</div>
                <Can do={USER_PERMISSIONS.CAN_EDIT_SAP_NOTIFICATION}>
                  {orderData?.data?.status !==
                    POSAP_STATUS_NOTIFICATED.code && (
                    <div className="col-1 text-end">
                      <div className="dropdown">
                        <DropdownToggle
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="fa-solid fa-ellipsis-vertical"></i>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu dropdown-menu-end">
                          <DropdownItem>
                            <button
                              className="dropdown-item"
                              type="button"
                              onClick={() => editNotification(bb)}
                            >
                              <i className="fa-solid fa-pen me-2"></i>
                              {t("forms.notificationSap.actions.edit")}
                            </button>
                          </DropdownItem>
                          <DropdownItem>
                            <button
                              className="dropdown-item text-danger"
                              type="button"
                              onClick={() => deleteNotification(bb)}
                            >
                              <i className="fa-solid fa-trash me-2"></i>
                              {t("forms.notificationSap.actions.delete")}
                            </button>
                          </DropdownItem>
                        </DropdownMenu>
                      </div>
                    </div>
                  )}
                </Can>
              </RowTable>
            );
          })}
        </>
      );
    } else {
      return (
        <div className="row">
          <div className="col-12 text-center">
            {t("forms.productionOrderSap.noProductions")}
          </div>
        </div>
      );
    }
  };

  const renderConsumption = (consumptions) => {
    if (consumptions && consumptions.length > 0) {
      return (
        <>
          <HeadTable className="row header">
            <div className="col-3">
              {t("forms.productionOrderSap.table.head.date")}
            </div>
            <div className="col-2">
              {t("forms.productionOrderSap.table.head.batch")}
            </div>
            <div className="col-2">
              {t("forms.productionOrderSap.table.head.product")}
            </div>
            <div className="col-2">
              {t("forms.productionOrderSap.table.head.typeMov")}
            </div>
            <div className="col-2">
              {t("forms.productionOrderSap.table.head.quantity")}
            </div>
            <Can do={USER_PERMISSIONS.CAN_EDIT_SAP_NOTIFICATION}>
              <div className="col-1"></div>
            </Can>
          </HeadTable>
          {consumptions.map((bb) => {
            return (
              <RowTable className="row mb-1 align-items-center" key={bb.uuid}>
                <div className="col-3">{`${getDateFormatTimeZone(
                  bb.sapDocumentDate,
                  "DD-MM-yyyy HH:mm:ss",
                )}`}</div>
                <div className="col-2">{bb.sapBatch}</div>
                <div className="col-2">{`${bb.sapMaterial}`}</div>
                <div className="col-2">{`${bb.sapType}`}</div>
                <div className="col-2">{`${bb.sapQuantityEntry}Kg`}</div>
                <Can do={USER_PERMISSIONS.CAN_EDIT_SAP_NOTIFICATION}>
                  {orderData?.data?.status !==
                    POSAP_STATUS_NOTIFICATED.code && (
                    <div className="col-1 text-end">
                      <div className="dropdown">
                        <DropdownToggle
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="fa-solid fa-ellipsis-vertical"></i>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu dropdown-menu-end">
                          <DropdownItem>
                            <button
                              className="dropdown-item"
                              type="button"
                              onClick={() => editNotification(bb)}
                            >
                              <i className="fa-solid fa-pen me-2"></i>
                              {t("forms.notificationSap.actions.edit")}
                            </button>
                          </DropdownItem>
                          <DropdownItem>
                            <button
                              className="dropdown-item text-danger"
                              type="button"
                              onClick={() => deleteNotification(bb)}
                            >
                              <i className="fa-solid fa-trash me-2"></i>
                              {t("forms.notificationSap.actions.delete")}
                            </button>
                          </DropdownItem>
                        </DropdownMenu>
                      </div>
                    </div>
                  )}
                </Can>
              </RowTable>
            );
          })}
        </>
      );
    } else {
      return (
        <div className="row">
          <div className="col-12 text-center">
            {t("forms.productionOrderSap.noConsumptions")}
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <div className="row justify-content-center mt-4 mt-md-5">
        <div className="col-12 col-md-11">
          <h3 className="title">{t("forms.productionOrderSap.detailTitle")}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          {orderData?.data && (
            <>
              <div className="row align-items-center mt-4 mb-3">
                <div className="col-6 subtitle">
                  <strong>{t("forms.productionOrderSap.entryData")}</strong>
                </div>
                <div className="col-6 text-end">
                  {orderData?.data.status === POSAP_STATUS_READY_TO_SEND.code &&
                    orderData.data.active === true && (
                      <button
                        type="button"
                        className="btn btn-secondary btn-md"
                        onClick={() => notify(orderData.data.uuid)}
                      >
                        <Icon className="fa-solid fa-file-pen"></Icon>
                        {t("forms.productionOrderSap.labels.notify")}
                      </button>
                    )}
                  {orderData?.data.status === POSAP_STATUS_PENDING.code && (
                    <button
                      type="button"
                      className="btn btn-secondary btn-md"
                      onClick={() => handlerOnExtraInfo()}
                    >
                      <Icon className="fa-solid fa-file-pen"></Icon>
                      {t("forms.productionOrderSap.labels.extraInfo")}
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-secondary btn-md m-1"
                    onClick={() => onExportExcel(orderData)}
                  >
                    <Icon className="fa-solid fa-file-excel"></Icon>
                    {t("forms.productionOrderSap.buttons.exportExcel")}
                  </button>
                </div>
              </div>
              <ContainerData>
                <div className="row">
                  <div className="col-6">
                    <LabelData>
                      {t("forms.productionOrderSap.labels.sapStartDate")}:
                    </LabelData>
                    {getDateFormatTimeZone(
                      orderData?.data.sapStartDate,
                      "DD-MM-yyyy HH:mm:ss",
                    )}
                  </div>
                  <div className="col-6">
                    <LabelData>
                      {t("forms.productionOrderSap.labels.status")}:
                    </LabelData>
                    {orderData?.data.status && (
                      <span className="text-secondary">
                        {t(
                          POSAP_STATUS.find(
                            (st) => st.code === orderData?.data.status,
                          ).label,
                        )}
                      </span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <LabelData>
                      {t("forms.productionOrderSap.labels.sapProduct")}:
                    </LabelData>
                    {orderData?.data.sapProduct}
                  </div>
                  <div className="col-6">
                    <LabelData>
                      {t("forms.productionOrderSap.labels.sapType")}:
                    </LabelData>
                    {orderData?.data.sapType}
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <LabelData>
                      {t("forms.productionOrderSap.labels.sapQuantity")}:
                    </LabelData>
                    {`${orderData?.data.sapQuantity} ${orderData?.data.sapProductionUnit}`}
                  </div>
                  <div className="col-6">
                    <LabelData>
                      {t("forms.productionOrderSap.labels.sapProductionUnit")}:
                    </LabelData>
                    {orderData?.data.sapProductionUnit}
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <LabelData>
                      {t("forms.productionOrderSap.labels.sapPlant")}:
                    </LabelData>
                    {orderData?.data.sapPlant}
                  </div>
                  <div className="col-6">
                    <LabelData>
                      {t("forms.productionOrderSap.labels.sapSchedulingType")}:
                    </LabelData>
                    {orderData?.data.sapSchedulingType}
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <LabelData>
                      {t(
                        "forms.productionOrderSap.labels.sapProductionVersion",
                      )}
                      :
                    </LabelData>
                    {orderData?.data.sapProductionVersion}
                  </div>
                  <div className="col-6">
                    <LabelData>
                      {t("forms.productionOrderSap.labels.idOrderSap")}:
                    </LabelData>
                    {orderData?.data.idOrderSap}
                  </div>
                </div>
              </ContainerData>
            </>
          )}
          <ContainerData className="mt-4">
            <div className="row">
              <div className="col-6">
                <LabelData>
                  {t("forms.productionOrderSap.labels.timeMachine")}:
                </LabelData>
                {orderData?.data.extraInfo?.sapMachineTime}
              </div>
              <div className="col-6">
                <LabelData>
                  {t("forms.productionOrderSap.labels.timeMenHour")}:
                </LabelData>
                {orderData?.data.extraInfo?.hourMen || "-"}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <LabelData>
                  {t("forms.productionOrderSap.labels.timeStopMachine")}:
                </LabelData>
                {orderData?.data.extraInfo?.sapMachineStoppedInMinutes || "0"}
              </div>
              <div className="col-6">
                <LabelData>
                  {t("forms.productionOrderSap.labels.sapTimeMendInMinutes")}:
                </LabelData>
                {orderData?.data.extraInfo?.sapTimeMendInMinutes || "0"}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <LabelData>
                  {t("forms.productionOrderSap.labels.timeNetoMachine")}:
                </LabelData>
                {orderData?.data.extraInfo?.sapMachineNetoTimeInMinutes || "0"}
              </div>
            </div>
          </ContainerData>
          <div className="row mt-4">
            <div className="col-6">
              <div className="row">
                <TitleProdCons className="col-12">
                  <div>
                    {t("forms.productionOrderSap.consumptions")}
                    {orderData?.consumptions?.length > 0 && (
                      <TotalKg>
                        (
                        {orderData.consumptions
                          .reduce(
                            (acc, c) => acc + Number(c.sapQuantityEntry ?? 0),
                            0,
                          )
                          .toFixed(2)}{" "}
                        Kg)
                      </TotalKg>
                    )}
                  </div>
                  {orderData?.data?.uuid && (
                    <Can do={USER_PERMISSIONS.CAN_EDIT_SAP_NOTIFICATION}>
                      {orderData?.data?.status !==
                        POSAP_STATUS_NOTIFICATED.code && (
                        <AddButton
                          type="button"
                          onClick={() =>
                            createNotification(orderData.data.uuid, 0)
                          }
                        >
                          <i className="fa-solid fa-plus me-1"></i>
                          {t("forms.notificationSap.actions.add")}
                        </AddButton>
                      )}
                    </Can>
                  )}
                </TitleProdCons>
              </div>
              <div className="row">
                <div className="col-12">
                  <ContainerProdCons>
                    {renderConsumption(orderData?.consumptions)}
                  </ContainerProdCons>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="row">
                <TitleProdCons className="col-12">
                  <div>
                    {t("forms.productionOrderSap.productions")}
                    {orderData?.productions?.length > 0 && (
                      <TotalKg>
                        (
                        {orderData.productions
                          .reduce(
                            (acc, p) => acc + Number(p.sapQuantityEntry ?? 0),
                            0,
                          )
                          .toFixed(2)}{" "}
                        Kg)
                      </TotalKg>
                    )}
                  </div>
                  {orderData?.data?.uuid && (
                    <Can do={USER_PERMISSIONS.CAN_EDIT_SAP_NOTIFICATION}>
                      {orderData?.data?.status !==
                        POSAP_STATUS_NOTIFICATED.code && (
                        <AddButton
                          type="button"
                          onClick={() =>
                            createNotification(orderData.data.uuid, 1)
                          }
                        >
                          <i className="fa-solid fa-plus me-1"></i>
                          {t("forms.notificationSap.actions.add")}
                        </AddButton>
                      )}
                    </Can>
                  )}
                </TitleProdCons>
              </div>
              <div className="row">
                <div className="col-12">
                  <ContainerProdCons>
                    {renderProduction(orderData?.productions)}
                  </ContainerProdCons>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center mt-5 mb-5">
        <div className="col-12 col-md-11 d-flex justify-content-center">
          <button
            className="btn btn-secondary btn-lg me-3 mb-2"
            onClick={() => goBack()}
          >
            {t("forms.productionOrderSap.buttons.backList")}
          </button>
        </div>
      </div>
    </>
  );
};

ProductionOrderSapDetailView.propTypes = {};

export default ProductionOrderSapDetailView;
